/* eslint-disable @typescript-eslint/no-explicit-any */
import { cn } from '~/lib/utils'
import MarkDown from '~/components/Helpers/MarkDown'
import HtmlBlock from '~/components/Helpers/HtmlBlock'
import sanitizeHtml from 'sanitize-html'

const FootNote = ({
  content,
  // backgroundColour,
  className
}: {
  content: { footnote: Array<string>; copy?: string }
  backgroundColour: 'white' | 'light-grey'
  className?: string
}) => {
  const { footnote, copy } = content

  return (
    <section
      // className={cn(backgroundColour === 'white' ? '' : 'bg-grey-l', className)}
      className={cn(className)}
      aria-label='Footnotes'
    >
      <div className='py-xs-plus sm:py-xl space-y-2xs-plus container'>
        {footnote &&
          footnote.map((item, index: Index) => {
            return (
              <div key={index} className='space-x-2xs flex items-start'>
                <span className='text-tag-sm w-xs-plus flex shrink-0 text-right font-mono'>
                  {index + 1}.
                </span>
                <MarkDown
                  content={item}
                  className='max-w-none'
                  components={{
                    p: ({ children }: any) => (
                      <p className='text-tag-sm tracking-normal'>{children}</p>
                    )
                  }}
                />
              </div>
            )
          })}
        {copy && (
          <div className='mt-s'>
            <HtmlBlock
              content={copy}
              className='max-w-none'
              opt={{
                transformTags: {
                  p: sanitizeHtml.simpleTransform('p', {
                    class: 'text-tag-sm tracking-normal text-pretty'
                  }),
                  a: sanitizeHtml.simpleTransform('a', {
                    class: 'text-tag-sm tracking-normal'
                  })
                }
              }}
            />
          </div>
        )}
      </div>
    </section>
  )
}

export default FootNote
